import { appFunc_senToken, appFunc_changeBar } from '@/utils/bridge'
import { CommonModule } from '@/store/modules/common'
import { getUserInfoAndMemberProduct } from '@/api'
import { isIOS } from '@/utils/device'

export default {
  data() {
    return {
      isFirst: 0,
      isRenew: false,
      memberProduct: {
        name: '',
        price: '',
        id: ''
      }
    }
  },
  methods: {
    async getToken() {
      const res = await appFunc_senToken()
      console.log(res, '/////////////')
      CommonModule.setUserId(res.id)
      CommonModule.setToken(res.tokenForJs)
      CommonModule.setUserPhone(res.mobile)
      CommonModule.setUserName(res.name)
    },
    getConfigList() {
      getUserInfoAndMemberProduct(isIOS ? 2 : 1).then(res => {
        if (res.code === 1001 && res.data) {
          try {
            this.isFirst = res.data?.isFirst
            this.userInfo = res.data?.userInfo || {}
            this.isRenew =
              res.data?.liveMemberProduct &&
              Object.keys(res.data?.liveMemberProduct).length > 0

            // 组合已订阅的会员信息
            if (this.isRenew) {
              this.memberProduct.name =
                this.language == 'ug'
                  ? res.data?.liveMemberProduct.nameUig
                  : res.data?.liveMemberProduct.name
              this.memberProduct.price =
                res.data?.liveMemberProduct.currentPrice
              this.memberProduct.id = res.data?.liveMemberProduct.id
            }
            this.memberProducts = res.data?.liveMemberProducts || []
            // 过滤已订阅的续费会员包
            if(res.data?.liveMemberProduct && (res.data?.liveMemberProduct?.type === 1)) {
              this.memberProducts = this.memberProducts.filter(
                item => item.id !== this.memberProduct.id
              )
            }
            // 检查会员是否到期
            this.checkVipStatus(this.userInfo?.liveMemberEndTime)
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    setLanguage() {
      // 获取当前语言
      const data = this.$route.query.language || 'ug'
      this.language = data
      console.log('setLanguage', this.language)
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
      appFunc_changeBar({ statusBarModel: false, navBarBackground: '#FFFFFF' })
    },
    toWebView(url, title) {
      this.$router.push({
        path: '/agreement-webview',
        query: {
          url,
          title,
          statusBarHeight: this.statusHeight
        }
      })
    },
    resultDesc() {
      if (
        Array.isArray(this.memberProducts) &&
        this.memberProducts.length &&
        this.activeVipIndex !== undefined
      ) {
        const product = this.memberProducts[this.activeVipIndex || 0]
        return product ? product.explain : ''
      }
      return ''
    },
    // 检测会员状态
    checkVipStatus(endTime) {
      if (!endTime) return
      const curentTime = new Date().getTime()
      endTime = new Date(endTime).getTime()
      const status = curentTime <= endTime
      this.isUserHaveVip = status
      return status
    }
  }
}
